import { useEffect, useState } from "react";
import { FilterFields } from "./Fields";
import {
  Box,
  Button,
  FormControl,
  Grid,
  MenuItem,
  Select,
  useTheme,
} from "@mui/material";
import { createYupSchema } from "../../utilities/yupSchemaCreator";
import { useForm } from "react-hook-form";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { FilterList } from "@mui/icons-material";
import { useCompany } from "../Companies/Provider";
import { useSite } from "../Sites/Provider";
import { CalUtcWithFormat } from "../../utilities/functions";
import { useReservation } from "./provider";
import { useAuth } from "../../services/auth";
import { useSubCompany } from "../SubCompanies/Provider";
// yup schema
const yupSchema = FilterFields.reduce(createYupSchema, {});
const formSchema = Yup.object().shape(yupSchema);

const FilterForm = () => {
  let theme = useTheme();

  const { role, adminOn } = useAuth();
  const [locale] = useState("en-gb");

  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(formSchema),
  });
  const {
    state: { selected: SubCompany },
  } = useSubCompany();
  const {
    state: { Names: companies },
    fetchNames: fetchCompanies,
  } = useCompany();
  const {
    state: { Names: sites, selected: siteInfo },
    fetchSiteNames: fetchSites,
  } = useSite();

  const {
    state: { companyId, page, perPage },
    fetchList,
    dispatch,
  } = useReservation();

  useEffect(() => {
    if (role === "Admin") fetchCompanies();
  }, [role]);
  useEffect(() => {
    if (role === "Company") {
      dispatch({ type: "set_CompanyId", payload: adminOn?.id });
    }
  }, [companyId, role]);
  useEffect(() => {
    if (companyId && role !== "SubCompany") fetchSites(companyId, 0);
  }, [companyId]);

  useEffect(() => {
    if (role === "SubCompany") fetchSites(SubCompany?.company?.id, adminOn?.id);
  }, [SubCompany, adminOn, role]);
  const getData = (name) => {
    const dataMap = {
      siteId: sites,
      companyId: companies,
    };

    return dataMap[name] || [];
  };
  useEffect(() => {
    if (role === "Site") {
      setValue("siteId", adminOn?.id);
    }
  }, [role, adminOn]);
  /**pagination */
  useEffect(() => {
    if (getValues("siteId")) fetchList(getValues(), page, perPage);
  }, [page, perPage]);

  const onSubmit = async (values) => {
    delete values?.companyId;
    delete values?.companyName;
    if (values.fromDate) {
      values.fromDate = CalUtcWithFormat(values.fromDate);
    }

    if (values.toDate) {
      values.toDate = CalUtcWithFormat(values.toDate);
    }
    try {
      await fetchList(values, page, perPage);
    } catch (error) {
      console.log(error, "error");
    }
  };
  return (
    <form onSubmit={handleSubmit(onSubmit)} noValidate>
      <Box sx={{ backgroundColor: "#f7f9fb", p: 2, width: "85%", mt: 1 }}>
        <Grid container spacing={2} columns={{ xs: 2, sm: 2, md: 2 }}>
          {FilterFields?.map((f, index) => (
            <Grid item xs={1} key={index}>
              {f.name === "siteId" && role === "Site" && (
                <Box>
                  <span style={{ fontSize: "12px" }}>Site</span>
                  <Box
                    sx={{
                      borderBottom: "1px solid gray",
                      width: "290px",
                      borderRadius: "8px",
                      textAlign: "center",
                      marginTop: "20px",
                    }}
                  >
                    {adminOn?.siteName}
                  </Box>
                </Box>
              )}
              {f.name === "companyId" && role === "Company" && (
                <Box>
                  <span style={{ fontSize: "12px" }}>Company</span>
                  <Box
                    sx={{
                      borderBottom: "1px solid gray",
                      width: "290px",
                      borderRadius: "8px",
                      textAlign: "center",
                      marginTop: "20px",
                    }}
                  >
                    {adminOn?.companyName}
                  </Box>
                </Box>
              )}
              {f.name === "companyId" && role === "Site" && (
                <Box>
                  <span style={{ fontSize: "12px" }}>Company</span>
                  <Box
                    sx={{
                      borderBottom: "1px solid gray",
                      width: "290px",
                      borderRadius: "8px",
                      textAlign: "center",
                      marginTop: "20px",
                    }}
                  >
                    {siteInfo?.company?.companyName}
                  </Box>
                </Box>
              )}
              {f.name === "companyId" && role === "SubCompany" && (
                <Box>
                  <span style={{ fontSize: "12px" }}>Company</span>
                  <Box
                    sx={{
                      borderBottom: "1px solid gray",
                      width: "290px",
                      borderRadius: "8px",
                      textAlign: "center",
                      marginTop: "20px",
                    }}
                  >
                    {SubCompany?.company?.companyName}
                  </Box>
                </Box>
              )}

              {f.select && (
                <FormControl
                  sx={{
                    width: theme.dimensions.width,
                    mt: theme.dimensions.mt,
                    mb: theme.dimensions.mb,
                    display:
                      f.name === "companyId" && role === "Company"
                        ? "none"
                        : "" || role === "Site"
                        ? "none"
                        : "" ||
                          (f.name === "companyId" && role === "SubCompany")
                        ? "none"
                        : "",
                  }}
                  value={f.name === "companyId" && companyId}
                  error={f.name === "companyId" || f.name === "siteId"}
                  required={f.required}
                >
                  <span style={{ fontSize: "12px" }}>
                    {f.label}
                    <>*</>
                  </span>
                  <Select
                    sx={{
                      mt: theme.dimensions.mt,
                    }}
                    error={!!errors[f.name]}
                    onChange={(e) => {
                      if (f.name === "companyId") {
                        dispatch({
                          type: "set_CompanyId",
                          payload: e.target.value,
                        });
                      }
                    }}
                    inputProps={{
                      ...register(f?.name),
                    }}
                    size="small"
                  >
                    {getData(f.name)?.map((s, index) => (
                      <MenuItem key={index} value={s.id}>
                        {s.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              )}
              {f.date && (
                <LocalizationProvider
                  dateAdapter={AdapterDayjs}
                  adapterLocale={locale}
                >
                  <FormControl
                    components={["DateRangePicker"]}
                    sx={{
                      width: theme.dimensions.width,
                      mt: theme.dimensions.mt,
                      mb: theme.dimensions.mb,
                    }}
                  >
                    <span style={{ fontSize: "12px" }}>{f.label}</span>
                    <DateTimePicker
                      sx={{ mt: 1 }}
                      error={!!errors[f.name]}
                      onChange={(date) => setValue(f.name, date)}
                      slotProps={{
                        textField: {
                          error: errors[f.name]?.message,
                          helperText: (
                            <p style={{ color: "#d32f2f" }}>
                              {errors[f.name]?.message}
                            </p>
                          ),
                          size: "small",
                        },
                      }}
                    />
                  </FormControl>
                </LocalizationProvider>
              )}
            </Grid>
          ))}
        </Grid>
        <Box sx={{ display: "flex", justifyContent: "end", mx: 4 }}>
          <Button
            variant="contained"
            type="submit"
            sx={{
              backgroundColor: theme.color.blackBackground,
              color: "white",
              ml: 5,
              "&:hover": { background: `${theme.color.blackBackground}` },
              textTransform: "capitalize",
            }}
          >
            <FilterList />
            <span style={{ margin: theme.spacing(0, 2) }}>Filter</span>
          </Button>
        </Box>
      </Box>
    </form>
  );
};

export default FilterForm;
